import React from "react";
import { Box, Typography } from "@mui/material";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import SiteLogo from "../component/SiteLogo";

export interface Props { }

const SUPPORT_EMAIL = "support@myedulink.net";

const MaintenancePage: React.FC<Props> = () => {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                px: 3,
                background: "linear-gradient(160deg, #f3faf6 0%, #eef3fb 100%)",
            }}
        >
            <Box sx={{ mb: 5 }}>
                <SiteLogo height={48} />
            </Box>

            <Box
                sx={{
                    width: 96,
                    height: 96,
                    borderRadius: "50%",
                    bgcolor: "rgba(48,146,85,0.10)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 4,
                }}
            >
                <ConstructionRoundedIcon sx={{ fontSize: 44, color: "#309255" }} />
            </Box>

            <Typography variant="h4" fontWeight={800} sx={{ color: "#1d2d50", mb: 1.5 }}>
                We&apos;ll be right back
            </Typography>

            <Typography variant="body1" sx={{ color: "text.secondary", maxWidth: 480, mb: 0.5 }}>
                We're performing scheduled maintenance to improve your experience.
                The site will be back online shortly — thanks for your patience.
            </Typography>

            <Typography variant="body2" sx={{ color: "text.secondary", mt: 3 }}>
                Need something urgent? Reach us at{" "}
                <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: "#309255", fontWeight: 600 }}>
                    {SUPPORT_EMAIL}
                </a>,
                Or Call:<a href="tel:+12362047735">+1(236) 204-7735</a>
            </Typography>
        </Box>
    );
};

export default MaintenancePage;
